var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.layout},[_c('ActionProcessing',{class:_vm.$style.preloader,attrs:{"type":"paymentLoading"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }